import { computed } from 'vue';
import { useRoute } from '#app/composables/router';
import { useSchemaEditability } from '#layers/data-model/composables/use-schema-editability';
import { useWorkspaceSchemaStore } from '#layers/data-model/stores/workspace-schema';
import { findItem } from '#layers/data-model/utils/filters/index';

export function useSchemaBasedOnRoute() {
	const route = useRoute();
	const schemaStore = useWorkspaceSchemaStore();
	const { isSchemaEditable } = useSchemaEditability();

	const sourceIdOrName = computed(() => route.params.source as string | undefined);
	const collectionIdOrName = computed(() => route.params.collection as string | undefined);

	const dataSource = computed(() => findItem(schemaStore.dataSources, {
		_or: [
			{
				id: { _eq: sourceIdOrName.value },
			},
			{
				apiName: { _eq: sourceIdOrName.value },
			},
		],
	}) ?? null);

	const collection = computed(() => {
		if (!dataSource.value) return null;

		const matchedCollection = findItem(dataSource.value.collections, {
			_or: [
				{
					id: { _eq: collectionIdOrName.value },
				},
				{
					dbName: { _eq: collectionIdOrName.value },
				},
			],
		});

		return matchedCollection?.isSystem ? null : matchedCollection;
	});

	return {
		dataSource,
		collection,
		isSchemaEditable: computed(() => !!dataSource.value && isSchemaEditable(dataSource.value)),
	};
}
